import { IconArrowNarrowDown } from "@tabler/icons-react";
import { useSearchParams } from "react-router-dom";
interface Props {
  dir?: string;
}
const SortArrow = ({ dir: defaultDir }: Props) => {
  const [searchParams] = useSearchParams();
  const dir = defaultDir ?? searchParams.get("dir");
  return (
    <IconArrowNarrowDown
      style={{
        position: "absolute",
        right: 0,
        top: "50%",
        transform:
          dir === "desc"
            ? `translate(100%, -50%)`
            : `translate(100%, -50%) rotate(180deg)`,
      }}
    />
  );
};
export default SortArrow;
